var map = {
	"./controlChart/controlChart.module": [
		"./src/app/user-view/controlChart/controlChart.module.ts",
		"common",
		"controlChart.module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"./nominationReport/nominationReport.module": [
		"./src/app/user-view/nominationReport/nominationReport.module.ts",
		"common",
		"nominationReport.module"
	],
	"./partyProfile/partyProfile.module": [
		"./src/app/user-view/partyProfile/partyProfile.module.ts",
		"common",
		"partyProfile.module"
	],
	"./proForma/proForma.module": [
		"./src/app/user-view/proForma/proForma.module.ts",
		"common",
		"proForma.module"
	],
	"./reports/reports.module": [
		"./src/app/user-view/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./superAdmin/superAdmin.module": [
		"./src/app/user-view/superAdmin/superAdmin.module.ts",
		"common",
		"superAdmin.module"
	],
	"./user-view/user-view.module": [
		"./src/app/user-view/user-view.module.ts",
		"user-view.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main